class Accordion extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute("data-id");
    const headers = [];
    setTimeout(() => {
      const details = document.querySelectorAll(`#${this.id}`);
      details.forEach((detail) => {
        const header = detail.querySelectorAll(".accordion-header");
        headers.push(...header);
      });
      this.headers = headers;
      this.init();
    }, 0);
  }

  init() {
    this.headers.forEach((header) => {
      header.addEventListener("click", () => this.toggleAccordion(header));
    });
  }

  toggleAccordion(clickedHeader) {
    const attr = this.getAttribute("data-accordion-enabled");
    const accordionEnabled = attr === null ? true : attr === "true";
    const duration = this.getAttribute("data-animation-duration") || 300;
    const isExpanded = clickedHeader.getAttribute("aria-expanded") === "true";
    const content = clickedHeader.nextElementSibling;
    // 如果开启手风琴模式，关闭其他打开的面板
    if (accordionEnabled) {
      this.headers.forEach((header) => {
        if (
          header !== clickedHeader &&
          header.getAttribute("aria-expanded") === "true"
        ) {
          header.setAttribute("aria-expanded", "false");
          header.nextElementSibling.style.maxHeight = "0px";
        }
      });
    }

    // 切换当前面板
    clickedHeader.setAttribute("aria-expanded", !isExpanded);
    if (!isExpanded) {
      // 打开面板
      content.style.transition = `max-height ${duration}ms ease`;
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      // 关闭面板
      content.style.maxHeight = "0px";
    }
  }
}

// 注册组件
customElements.define("accordion-component", Accordion);
